export default {"src":"/_next/static/media/Alchemy.3fa07ba7.svg","height":32,"width":32};